import React, { useEffect, useMemo, useState } from "react";
import api from "../api/axios";

const panelCss = `
.prc-panel {
  width: 100%;
  color: #07111f;
}

.prc-panel * {
  box-sizing: border-box;
}

.prc-card {
  position: relative;
  overflow: hidden;
  margin: 14px 0;
  padding: 18px;
  border-radius: 22px;
  border: 1px solid #cddcec;
  background:
    radial-gradient(circle at 100% 0%, rgba(24, 183, 255, 0.12), transparent 34%),
    linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  box-shadow: 0 14px 36px rgba(7, 17, 31, 0.065);
}

.prc-card.dark {
  color: white;
  background:
    radial-gradient(circle at 100% 0%, rgba(24, 183, 255, 0.22), transparent 34%),
    linear-gradient(145deg, #03060c, #081525 62%, #06101f);
  border-color: rgba(24, 183, 255, 0.18);
  box-shadow: 0 20px 55px rgba(3, 6, 12, 0.16);
}

.prc-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 14px;
}

.prc-kicker {
  display: block;
  margin-bottom: 8px;
  color: #125a94;
  font-size: 10px;
  font-weight: 950;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.prc-card.dark .prc-kicker {
  color: #9fdcff;
}

.prc-title {
  margin: 0;
  color: #07111f;
  font-size: 19px;
  line-height: 1.16;
  letter-spacing: -0.045em;
  font-weight: 950;
}

.prc-card.dark .prc-title {
  color: #ffffff;
}

.prc-subtitle {
  margin: 7px 0 0;
  color: #66778e;
  font-size: 13px;
  line-height: 1.55;
}

.prc-card.dark .prc-subtitle {
  color: #a9bdd3;
}

.prc-chip {
  flex: 0 0 auto;
  min-height: 28px;
  padding: 7px 10px;
  border-radius: 999px;
  color: #0b4e84;
  background: rgba(31, 123, 193, 0.10);
  border: 1px solid rgba(31, 123, 193, 0.18);
  font-size: 11px;
  font-weight: 950;
  white-space: nowrap;
}

.prc-card.dark .prc-chip {
  color: #bfeaff;
  background: rgba(24,183,255,0.12);
  border-color: rgba(24,183,255,0.18);
}

.prc-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.prc-metric {
  min-height: 82px;
  padding: 14px;
  border-radius: 16px;
  background: #f7fbff;
  border: 1px solid #d9e8f6;
}

.prc-card.dark .prc-metric {
  background: rgba(255,255,255,0.075);
  border-color: rgba(24,183,255,0.12);
}

.prc-metric span {
  display: block;
  margin-bottom: 7px;
  color: #75869d;
  font-size: 9px;
  font-weight: 950;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.prc-card.dark .prc-metric span {
  color: #9fdcff;
}

.prc-metric strong {
  display: block;
  color: #07111f;
  font-size: 16px;
  font-weight: 950;
  overflow-wrap: anywhere;
}

.prc-card.dark .prc-metric strong {
  color: #ffffff;
}

.prc-metric small {
  display: block;
  margin-top: 5px;
  color: #66778e;
  line-height: 1.35;
}

.prc-card.dark .prc-metric small {
  color: #a9bdd3;
}

.prc-status-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;
  margin-top: 12px;
  padding: 13px;
  border-radius: 16px;
  background: #eef6ff;
  border: 1px solid #d9e8f6;
}

.prc-card.dark .prc-status-row {
  background: rgba(255,255,255,0.07);
  border-color: rgba(24,183,255,0.12);
}

.prc-status-row strong {
  color: #07111f;
  font-size: 13px;
  font-weight: 950;
}

.prc-card.dark .prc-status-row strong {
  color: white;
}

.prc-status-row span {
  display: block;
  margin-top: 4px;
  color: #66778e;
  font-size: 12px;
  line-height: 1.45;
}

.prc-card.dark .prc-status-row span {
  color: #a9bdd3;
}

.prc-refresh-btn {
  min-height: 36px;
  padding: 9px 12px;
  border-radius: 11px;
  border: 1px solid transparent;
  color: white;
  background: linear-gradient(135deg, #1f7bc1, #0f5f9d);
  box-shadow: 0 12px 24px rgba(31, 123, 193, 0.20);
  cursor: pointer;
  font-size: 12px;
  font-weight: 950;
  white-space: nowrap;
}

.prc-refresh-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.prc-section {
  margin-top: 14px;
  padding: 14px;
  border-radius: 17px;
  background: rgba(255,255,255,0.94);
  border: 1px solid #d9e8f6;
}

.prc-card.dark .prc-section {
  background: rgba(255,255,255,0.065);
  border-color: rgba(24,183,255,0.12);
}

.prc-section h4 {
  margin: 0 0 8px;
  color: #07111f;
  font-size: 14px;
  font-weight: 950;
  letter-spacing: -0.02em;
}

.prc-card.dark .prc-section h4 {
  color: white;
}

.prc-section p {
  margin: 0;
  color: #66778e;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
}

.prc-card.dark .prc-section p {
  color: #dbeafe;
}

.prc-list {
  display: grid;
  gap: 8px;
  margin-top: 9px;
}

.prc-list-item {
  display: grid;
  gap: 4px;
  padding: 11px 12px;
  border-radius: 14px;
  background: #f7fbff;
  border: 1px solid #d9e8f6;
}

.prc-card.dark .prc-list-item {
  background: rgba(255,255,255,0.07);
  border-color: rgba(24,183,255,0.10);
}

.prc-list-item strong {
  color: #07111f;
  font-size: 13px;
  font-weight: 950;
}

.prc-card.dark .prc-list-item strong {
  color: white;
}

.prc-list-item span {
  color: #66778e;
  font-size: 12px;
  line-height: 1.45;
}

.prc-card.dark .prc-list-item span {
  color: #a9bdd3;
}

.prc-empty {
  padding: 14px;
  border-radius: 16px;
  color: #66778e;
  background: #f7fbff;
  border: 1px dashed #cddcec;
  font-size: 13px;
  line-height: 1.5;
}

.prc-card.dark .prc-empty {
  color: #a9bdd3;
  background: rgba(255,255,255,0.05);
  border-color: rgba(24,183,255,0.18);
}

.prc-error {
  margin-top: 12px;
  padding: 12px;
  border-radius: 14px;
  color: #991b1b;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.18);
  font-size: 13px;
  line-height: 1.45;
}

.prc-pulse {
  position: relative;
  height: 92px;
  margin-top: 14px;
  overflow: hidden;
  border-radius: 17px;
  background:
    linear-gradient(90deg, rgba(24,183,255,0.03), rgba(24,183,255,0.10), rgba(24,183,255,0.03)),
    #f7fbff;
  border: 1px solid #d9e8f6;
}

.prc-card.dark .prc-pulse {
  background:
    linear-gradient(90deg, rgba(24,183,255,0.03), rgba(24,183,255,0.10), rgba(24,183,255,0.03)),
    rgba(255,255,255,0.05);
  border-color: rgba(24,183,255,0.12);
}

.prc-wave {
  position: absolute;
  left: 0;
  top: 18px;
  width: 200%;
  height: 56px;
  background:
    linear-gradient(90deg, transparent, rgba(24,183,255,0.25), transparent),
    repeating-linear-gradient(
      90deg,
      transparent 0 18px,
      rgba(31,123,193,0.11) 18px 19px
    );
  clip-path: polygon(
    0% 55%, 4% 45%, 8% 54%, 12% 42%, 16% 62%, 20% 44%,
    24% 58%, 28% 41%, 32% 60%, 36% 48%, 40% 52%, 44% 39%,
    48% 66%, 52% 43%, 56% 55%, 60% 45%, 64% 58%, 68% 41%,
    72% 61%, 76% 49%, 80% 55%, 84% 39%, 88% 62%, 92% 46%,
    96% 56%, 100% 50%, 100% 100%, 0% 100%
  );
  animation: prcWave 5s linear infinite;
}

@keyframes prcWave {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}

@media (max-width: 760px) {
  .prc-head,
  .prc-status-row {
    grid-template-columns: 1fr;
    display: grid;
  }

  .prc-chip {
    width: fit-content;
  }

  .prc-grid {
    grid-template-columns: 1fr;
  }

  .prc-refresh-btn {
    width: 100%;
  }
}
`;

function textFrom(value, fallback = "—") {
  if (!value) return fallback;
  if (typeof value === "string") return value;
  if (typeof value === "number") return String(value);

  return (
    value.name ||
    value.title ||
    value.summary ||
    value.description ||
    value.concern ||
    value.test ||
    value.specialist ||
    value.region ||
    value.note ||
    fallback
  );
}

function shortText(value, limit = 120) {
  const text = String(value || "").trim();
  if (!text) return "—";
  if (text.length <= limit) return text;
  return `${text.slice(0, limit)}...`;
}

function normalizeAnalysis(rawAnalysis) {
  if (!rawAnalysis) return null;

  const payload = rawAnalysis.analysis_json || rawAnalysis || {};

  return {
    initial_summary: payload.initial_summary || rawAnalysis.initial_summary || "",
    possible_concerns:
      payload.possible_concerns || rawAnalysis.possible_concerns || [],
    suggested_tests:
      payload.suggested_tests || rawAnalysis.suggested_tests || [],
    suggested_specialists:
      payload.suggested_specialists || rawAnalysis.suggested_specialists || [],
    medicine_concerns:
      payload.medicine_concerns || rawAnalysis.medicine_concerns || [],
    brain_regions:
      payload.brain_regions || rawAnalysis.brain_regions || [],
    doctor_note: payload.doctor_note || rawAnalysis.doctor_note || "",
    triage: payload.triage || rawAnalysis.triage || null,
    raw_text: rawAnalysis.raw_text || payload.raw_text || "",
  };
}

function formatDate(value) {
  if (!value) return "No date";

  try {
    return new Date(value).toLocaleString();
  } catch {
    return "No date";
  }
}

function pickLatestSession(sessions = []) {
  if (!sessions.length) return null;

  return [...sessions].sort((a, b) => {
    const dateA = new Date(a.created_at || a.started_at || 0).getTime();
    const dateB = new Date(b.created_at || b.started_at || 0).getTime();

    if (dateA !== dateB) return dateB - dateA;
    return Number(b.id || 0) - Number(a.id || 0);
  })[0];
}

export default function PatientResearchContextPanel({
  patientId,
  selectedPatient,
  onContextChange,
}) {
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [latestSession, setLatestSession] = useState(null);
  const [analysis, setAnalysis] = useState(null);
  const [error, setError] = useState("");

  const contextPayload = useMemo(() => {
    if (!patientId || !selectedPatient) return null;

    return {
      patient_id: Number(patientId),
      patient_name: selectedPatient?.name || null,
      patient_age: selectedPatient?.age ?? null,
      patient_gender: selectedPatient?.gender || null,
      patient_relation: selectedPatient?.relation || "self",
      session_id: latestSession?.id || null,
      session_title: latestSession?.title || null,
      session_created_at: latestSession?.created_at || latestSession?.started_at || null,
      session_count: sessions.length,
      summary: analysis?.initial_summary || latestSession?.summary || "",
      initial_summary: analysis?.initial_summary || "",
      possible_concerns: analysis?.possible_concerns || [],
      suggested_tests: analysis?.suggested_tests || [],
      suggested_specialists: analysis?.suggested_specialists || [],
      medicine_concerns: analysis?.medicine_concerns || [],
      brain_regions: analysis?.brain_regions || [],
      doctor_note: analysis?.doctor_note || "",
      triage: analysis?.triage || null,
      raw_text: analysis?.raw_text || "",
      source: analysis ? "latest_session_analysis" : "patient_profile_only",
    };
  }, [patientId, selectedPatient, latestSession, sessions, analysis]);

  useEffect(() => {
    onContextChange?.(contextPayload);
  }, [contextPayload, onContextChange]);

  useEffect(() => {
    loadContext();
    
  }, [patientId]);

  const loadContext = async () => {
    setError("");
    setAnalysis(null);
    setLatestSession(null);
    setSessions([]);

    if (!patientId) {
      onContextChange?.(null);
      return;
    }

    try {
      setLoading(true);

      const sessionRes = await api.get(`/api/session/patient/${patientId}`);
      const sessionRows = Array.isArray(sessionRes.data) ? sessionRes.data : [];

      setSessions(sessionRows);

      const latest = pickLatestSession(sessionRows);
      setLatestSession(latest || null);

      if (!latest?.id) {
        return;
      }

      try {
        const detailRes = await api.get(`/api/session/detail/${latest.id}`);
        const payload = detailRes.data || {};
        setAnalysis(normalizeAnalysis(payload.analysis || null));
      } catch {
        setAnalysis(null);
      }
    } catch (err) {
      console.error("Failed to load patient research context", err);
      setError(
        err?.response?.data?.detail ||
          "Could not load patient research context."
      );
      onContextChange?.(null);
    } finally {
      setLoading(false);
    }
  };

  const concernCount = analysis?.possible_concerns?.length || 0;
  const testCount = analysis?.suggested_tests?.length || 0;
  const medicineCount = analysis?.medicine_concerns?.length || 0;
  const specialistCount = analysis?.suggested_specialists?.length || 0;

  if (!patientId) {
    return (
      <div className="prc-panel">
        <style>{panelCss}</style>

        <div className="prc-card dark">
          <div className="prc-head">
            <div>
              <span className="prc-kicker">Patient Research Context</span>
              <h3 className="prc-title">No patient attached</h3>
              <p className="prc-subtitle">
                Select a patient to load clinical history, latest session, AI
                analysis, and research context for avatar simulation.
              </p>
            </div>

            <span className="prc-chip">0 sessions</span>
          </div>

          <div className="prc-pulse">
            <div className="prc-wave" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="prc-panel">
      <style>{panelCss}</style>

      <div className="prc-card dark">
        <div className="prc-head">
          <div>
            <span className="prc-kicker">Patient Research Context</span>
            <h3 className="prc-title">
              {selectedPatient?.name || `Patient #${patientId}`}
            </h3>
            <p className="prc-subtitle">
              Clinical history and latest MedGen analysis are attached as
              research context for drug-combination and avatar simulation.
            </p>
          </div>

          <span className="prc-chip">
            {sessions.length} {sessions.length === 1 ? "session" : "sessions"}
          </span>
        </div>

        <div className="prc-grid">
          <div className="prc-metric">
            <span>Age</span>
            <strong>{selectedPatient?.age ?? "—"}</strong>
            <small>Patient profile value</small>
          </div>

          <div className="prc-metric">
            <span>Gender</span>
            <strong>{selectedPatient?.gender || "—"}</strong>
            <small>Used for avatar baseline</small>
          </div>

          <div className="prc-metric">
            <span>Latest session</span>
            <strong>{latestSession?.id ? `#${latestSession.id}` : "—"}</strong>
            <small>{formatDate(latestSession?.created_at || latestSession?.started_at)}</small>
          </div>

          <div className="prc-metric">
            <span>Analysis</span>
            <strong>{analysis ? "Attached" : "Pending"}</strong>
            <small>{analysis ? "AI context available" : "No analysis found"}</small>
          </div>
        </div>

        <div className="prc-status-row">
          <div>
            <strong>
              {loading
                ? "Loading clinical context..."
                : analysis
                  ? "Clinical history attached"
                  : "Profile context only"}
            </strong>
            <span>
              {analysis
                ? "Research simulation will include latest summary, concerns, tests, specialists, medicines, and brain-region notes."
                : "Run a clinical session analysis first to make this context more intelligent."}
            </span>
          </div>

          <button
            type="button"
            className="prc-refresh-btn"
            onClick={loadContext}
            disabled={loading}
          >
            {loading ? "Refreshing..." : "Refresh"}
          </button>
        </div>

        <div className="prc-pulse">
          <div className="prc-wave" />
        </div>

        {error && <div className="prc-error">{error}</div>}
      </div>

      <div className="prc-card">
        <div className="prc-head">
          <div>
            <span className="prc-kicker">Attached Intelligence</span>
            <h3 className="prc-title">Latest clinical signals</h3>
            <p className="prc-subtitle">
              These values are passed upward to the Research Lab page through
              the existing <b>onContextChange</b> callback.
            </p>
          </div>

          <span className="prc-chip">
            {concernCount + testCount + medicineCount + specialistCount} signals
          </span>
        </div>

        {!analysis ? (
          <div className="prc-empty">
            No AI analysis found for latest session. The simulation can still
            run with patient profile, BMI, face profile, and selected compounds.
          </div>
        ) : (
          <>
            <div className="prc-section">
              <h4>Clinical Summary</h4>
              <p>{analysis.initial_summary || latestSession?.summary || "No summary available."}</p>
            </div>

            <div className="prc-grid">
              <div className="prc-metric">
                <span>Concerns</span>
                <strong>{concernCount}</strong>
                <small>Possible issues mentioned</small>
              </div>

              <div className="prc-metric">
                <span>Tests</span>
                <strong>{testCount}</strong>
                <small>Investigation suggestions</small>
              </div>

              <div className="prc-metric">
                <span>Specialists</span>
                <strong>{specialistCount}</strong>
                <small>Referral directions</small>
              </div>

              <div className="prc-metric">
                <span>Medicines</span>
                <strong>{medicineCount}</strong>
                <small>Medicine concern items</small>
              </div>
            </div>

            <div className="prc-section">
              <h4>Medicine Context</h4>

              {analysis.medicine_concerns?.length ? (
                <div className="prc-list">
                  {analysis.medicine_concerns.slice(0, 4).map((item, index) => (
                    <div className="prc-list-item" key={`medicine-${index}`}>
                      <strong>{shortText(textFrom(item), 70)}</strong>
                      <span>{shortText(textFrom(item), 180)}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <p>No medicine concern found in latest analysis.</p>
              )}
            </div>

            <div className="prc-section">
              <h4>Tests / Specialist Context</h4>

              <div className="prc-list">
                {(analysis.suggested_tests || []).slice(0, 3).map((item, index) => (
                  <div className="prc-list-item" key={`test-${index}`}>
                    <strong>Test: {shortText(textFrom(item), 70)}</strong>
                    <span>Can be used as investigation context in avatar simulation.</span>
                  </div>
                ))}

                {(analysis.suggested_specialists || []).slice(0, 3).map((item, index) => (
                  <div className="prc-list-item" key={`specialist-${index}`}>
                    <strong>Specialist: {shortText(textFrom(item), 70)}</strong>
                    <span>Can guide organ/system impact interpretation.</span>
                  </div>
                ))}

                {!analysis.suggested_tests?.length &&
                  !analysis.suggested_specialists?.length && (
                    <div className="prc-empty">
                      No tests or specialists available from latest analysis.
                    </div>
                  )}
              </div>
            </div>

            {analysis.brain_regions?.length > 0 && (
              <div className="prc-section">
                <h4>Brain Region Context</h4>
                <div className="prc-list">
                  {analysis.brain_regions.slice(0, 4).map((item, index) => (
                    <div className="prc-list-item" key={`brain-${index}`}>
                      <strong>{shortText(textFrom(item), 70)}</strong>
                      <span>{shortText(textFrom(item), 180)}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}